// メッセージMap
export const MessageMap = {
    "education_date": "入国日"
    
};